const EventBus = window.EventBus;

export const AdvancedListWViewMore = {
  template: `
  <div class="new-list-w-view-more-content">
    <div class="relative"  @click.stop="display(component)" >
      <div v-if="disabled" class="absolute top-0 bottom-0 left-0 right-0 opacity-75 search-dropdown-content"></div>
      <div class="w-full flex content-between new-list-w-view-more-title-section"
           role="button"
           tabindex="0"
           :aria-expanded="show ? 'true' : 'false'"
           :aria-controls="'lbx-filter-' + component"
           :aria-disabled="disabled ? 'true' : null"
           @keydown.enter.prevent.stop="display(component)"
           @keydown.space.prevent.stop="display(component)">
        <div @click.stop="display(component)" :class="['py-2 flex items-center relative select-none w-full text-left text-base font-antenna-cond-bold overflow-hidden cursor-pointer capitalize new-list-w-view-more-title-text', {'text-darkGrey lbx-list-view-more-disabled': disabled, 'text-dark lbx-list-view-more-enabled': !disabled}]">
          {{title}}
          <span class="absolute right-0 select-none">
            <svg aria-hidden="true" focusable="false" :class="{'rotate-180': show}" width="14" height="10" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0L8 10.5245L16 0H13.3333L8 7.23556L2.66667 0H0Z" fill="#39393C"/>
            </svg>
          </span>
        </div>
      </div>
      <transition name="accordion">
        <div @click.stop="" v-if="show" :id="'lbx-filter-' + component" :class="[isResponsive ? 'lg:absolute' : '', !expanded ? 'h-auto max-h-[100px]' : '']" class="w-full z-50 bg-white new-list-w-view-more-items overflow-y-hidden flex flex-col gap-[6px]">
          <div class="list-w-view-more-item" v-for="item in items">
            <label class="new-custom-checkbox text-left text-sm">
              {{$t(item)}} 
              {{component == 'enginedisplacement' ? 'L' : ''}}
              {{getCount(item)}}
              <input
                @change="toggle(component, item)"
                :key="item" 
                type="checkbox"
                :value="item"
                :name="item"
                :checked="selected.includes(item)">
              <span class="checkmark rounded-md h-4 w-4"></span>
            </label>
          </div>
        </div>
      </transition>
    </div>
    <p v-show="!showAllOptions && !expanded && items.length > 4 && show" @click="expand(true)" class="mt-2 flex items-center text-left cursor-pointer text-dark list-w-view-more-button text-sm">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 13.1429H13.1429V20H10.8571V13.1429H4V10.8571H10.8571V4H13.1429V10.8571H20V13.1429Z" fill="#39393C"/>
      </svg>

      {{$t('View more')}}
    </p>
    <p v-show="!showAllOptions && expanded && items.length > 4 && show" @click="expand(false)" class="mt-2 flex items-center text-left cursor-pointer text-dark list-w-show-less-button text-sm"><span class="font-primary-bold text-xl">-</span>&nbsp;&nbsp;{{$t('Show less')}}</p>
  </div>
  `,
  data: function () {
    return {
      // `show-all-options` filter setting: start expanded (full list, no
      // "View more"/"Show less" toggle). Defaults to the collapsed behaviour.
      expanded: this.showAllOptions === true,
      show: false,
      uniqueInList: null,
      loaded: false,
      theme_directory: window.theme_directory,
      selected: this.initialSelection,
      enable: true,
      externalDisplayName: null,
      tags: [],
    };
  },
  props: [
    "component",
    "title",
    "items",
    "initialSelection",
    "collapse",
    "pivot",
    "disable-responsive",
    "optionsCount",
    "templateType",
    "defaultOpenSections",
    "showAllOptions"
  ],
  created() {
    // Sections listed in the filter `default-open-sections` option start
    // open (keys match the `component` prop, e.g. "location" for Dealership).
    this.show = this.isDefaultOpen;
  },
  mounted() {
    EventBus.$on("CLEAR_ALL_NEW_TOGGLE_LIST_ABSOLUTE_ADVANCED_SELECTION",() => {
      this.clearSelection();
      // Clear All restores the default state: open when the section is in
      // `default-open-sections`, collapsed otherwise (previous behaviour).
      this.show = this.isDefaultOpen;
    });
    EventBus.$on("NEW_TOGGLE_LIST_ABSOLUTE_ENTRY_POINT", () => { });

    // LBT-1461: keep the "feature" selection in sync with the horizontal
    // Popular Features bar (feature-quick-bar), which can live in a different
    // component/instance. Display-only mirror; the parent already owns
    // selected.feature for filtering/URL. Guard by component + source _uid.
    EventBus.$on("SYNC_FEATURE_SELECTION", (payload) => {
      if (this.component !== "feature") return;
      if (!payload || payload.source === this._uid) return;
      this.selected = Array.isArray(payload.selected) ? payload.selected.slice() : [];
    });

    // check if initialSelection has something when the component is mounted, to add the tags on first load
    if (this.initialSelection.length > 0) {
      this.initialSelection.forEach((item) => {
        this.$emit("updatetags", {
          component: this.component,
          selected: item.replace(/-/g, ' '),
          status: true,
        });
      });
    }
  },
  methods: {
    getCount(item) {
      if (this.optionsCount && this.optionsCount[item])
        return `(${this.optionsCount[item]})`;
      else return "";
    },
    entryPoint(items) {
      this.selected = items.filter((i) => {
        if (
          this.initialSelection.includes(
            i.replace(/ /g, "-").replace(/---/g, "-").toLowerCase()
          )
        )
          return i;
      });
      this.$emit("updatechecked", {
        component: this.component,
        selected: this.selected,
      });
    },
    clearSelection() {
      this.selected = [];
      this.expanded = this.showAllOptions === true;
      this.$emit("updatechecked", {
        component: this.component,
        selected: this.selected,
      });
    },
    display() {
      if (!this.hasItems() || !this.enable) return;
      this.show = !this.show;
    },
    expand(val) {
      this.expanded = val;
    },
    hasItems() {
      return this.items.length > 0;
    },
    toggle(component, item) {
      var enabled = true;

      if (this.selected.includes(item)){
        enabled = false;
        this.selected.splice(this.selected.indexOf(item), 1);
      }
        else this.selected.push(item);

      this.$emit("updatechecked", {
        component,
        selected: this.selected,
      });

      this.$emit("updatetags", {
        component,
        selected: item,
        status: enabled,
      });

      // LBT-1461: mirror feature toggles to the horizontal bar.
      if (component === "feature") {
        EventBus.$emit("SYNC_FEATURE_SELECTION", {
          source: this._uid,
          selected: this.selected.slice(),
        });
      }
    },
  },
  watch: {
    items(items) {
      if (!this.loaded) {
        this.entryPoint(items);
        this.loaded = true;
      }
    },
  },
  computed: {
    isDefaultOpen() {
      return Array.isArray(this.defaultOpenSections) &&
        this.defaultOpenSections.indexOf(String(this.component || '').toLowerCase()) !== -1;
    },
    disabled() {
      return !this.hasItems() || !this.enable;
    },
    displayName() {
      if (this.externalDisplayName) return this.externalDisplayName;
      if (this.selected.length == 0) return this.title;
      else if (this.selected.length > 2)
        return `${this.selected.slice(0, 2).join(",")}...`;
      else return this.selected.join(",");
    },
    isResponsive() {
      return !this.disableResponsive == true;
    },
  },
};
